import { render } from "./BaseCopier.vue?vue&type=template&id=91469de2&scoped=true"
import script from "./BaseCopier.vue?vue&type=script&lang=js"
export * from "./BaseCopier.vue?vue&type=script&lang=js"

import "./BaseCopier.vue?vue&type=style&index=0&id=91469de2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91469de2"]])

export default __exports__